// Web module: vendors (lane ops). Drata Vendors directory, the vendor profile tabs (Overview is the generic tab,
// History the generic history tab) and the SOC report tab of a security review.
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    vendor: {
      ListPage: lazyComponent(() => import('./VendorsListPage'), 'VendorsListPage'),
      detailTabs: [
        {
          id: 'reviews',
          label: 'Security reviews',
          order: 30,
          component: lazyComponent(() => import('./VendorTabs'), 'VendorReviewsTab'),
        },
        {
          id: 'documents',
          label: 'Reports and documents',
          order: 40,
          component: lazyComponent(() => import('./VendorTabs'), 'VendorDocumentsTab'),
        },
        {
          id: 'risk',
          label: 'Risk',
          order: 50,
          component: lazyComponent(() => import('./VendorTabs'), 'VendorRiskTab'),
        },
      ],
    },
    vendor_review: {
      detailTabs: [
        {
          id: 'soc',
          label: 'SOC report',
          order: 15,
          component: lazyComponent(() => import('./VendorTabs'), 'VendorReviewSocTab'),
          visible: ({ record }) => record.type === 'SOC_REPORT' || record.type === 'SOC_REPORT_REVIEW',
        },
      ],
    },
  },
}
